import React from 'react';
import { forecastDirectionLabel } from './types';

const SAMPLE_PCT = 65;

// Static, self-contained illustration for the widget library modal — no state,
// no API. Shows the slider at a representative bullish reading.
const Preview: React.FC = () => (
  <div className="h-full flex flex-col items-center justify-center gap-2 px-4 bg-surface">
    <span className="text-[10px] uppercase tracking-wider text-neutral-400 font-medium">
      P(up after print)
    </span>
    <div className="text-center">
      <span className="text-4xl font-bold tabular-nums text-success-500">{SAMPLE_PCT}%</span>
      <p className="text-xs font-medium mt-0.5 text-success-500">
        {forecastDirectionLabel(SAMPLE_PCT / 100)}
      </p>
    </div>
    <input
      type="range"
      min={0}
      max={100}
      value={SAMPLE_PCT}
      readOnly
      aria-hidden
      className="w-full max-w-[220px] accent-primary-500 pointer-events-none"
    />
    <div className="flex justify-between w-full max-w-[220px] text-[10px] text-neutral-500">
      <span>Down</span>
      <span>Up</span>
    </div>
  </div>
);

export default Preview;
